// Module
var code = " <button class=\"dv-btn dossier-toolbar-mobile-open\" ng-click=\"vm.toggleSidenav('dossier-toolbar-mobile')\" data-test=\"mobile-menu-button\"> <span class=\"fa fa-bars\"></span> </button> ";
// Exports
module.exports = code;